<!-- author Kalpesh modified date: 3/1/2022-->
<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div style="margin-top:3%">
        <div class="vaultDataloadHeadDiv">
            <h4>Database Migration</h4>
        </div>
    </div>
 <div class="main-grid">
    <!-- Configuration -->
    <div class="card-split">
         <div class="card-title">
            <div class="icon-circle">
                <mat-icon>settings</mat-icon>
            </div>
            <div>
            <label style="font-weight: 500; font-size: x-large;margin-bottom: 0;">Configuration</label>
            </div>
        </div>
        <form novalidate [formGroup]='FormValidS3'>
            <div class="form-grid">
                    <div class="field">
                        <label>Deferred Sets</label>
                         <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Deferred Sets</mat-label>
                              <input matInput type="text" placeholder="Deferred Sets" formControlName="defferedSets" id="defferedSets" [(ngModel)]="defferedData.defferedSets" readonly>
                        </mat-form-field>
                        
                    </div>
                    <div class="field">
                         <label>Deferred Objects</label>
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Deferred Objects</mat-label>
                         
                             <input matInput type="text" placeholder="Deferred Objects" formControlName="defferedObjects" id="defferedObjects" [(ngModel)]="defferedData.defferedObjects" readonly>
                        </mat-form-field>
                    </div>
                     <div class="field">
                        <label>Migration Sets</label>
                         <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Migration Sets</mat-label>
                             <input matInput type="text" placeholder="Migration Sets" formControlName="migrationSets" id="migrationSets" [(ngModel)]="defferedData.migrationSets" readonly>
                        </mat-form-field>
                       
                     </div>
                       <div class="field">
                        <label>Set Size</label>
                         <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Set Size</mat-label>
                             <input matInput type="text" placeholder="Set Size" formControlName="setSize" id="setSize" [(ngModel)]="defferedData.setSize" readonly>
                        </mat-form-field>
                       
                     </div>
                </div>
                 <div class="info-row">
                    <b>Mapping Snapshot</b>
                    <span>{{MappingFile}}</span>
                 </div>
                  <div class="action-row">
                    <div>
                    <b>Target Library Objects</b>
                    </div>
                      <app-common-button  label="Refresh" title="Refresh" icon="fas fa-refresh" style="margin-left: 5px;"
                    [buttonId]="119" [critical]="true" width="100px"(clicked)="refreshVaultObjects()">
                </app-common-button>
                </div>
                <div class="action-row">
                    <b>Add Sets for Migration</b>
                    <app-common-button  label="Add Sets" title="Add Sets" icon="fas fa-plus-circle" style="margin-left: 5px;"
                    [buttonId]="120" [critical]="true" width="100px"(clicked)="addSets()">
          </app-common-button>
                </div>
        </form>
        </div>
        <div class="card-split">
            <div class="run-header">
             <div class="card-title">
                <div class="icon-circle">
                    <mat-icon>play_arrow</mat-icon>
                </div>
                <div>
                     <label style="font-weight: 500; font-size: x-large;margin-bottom: 0;">Start Run</label>
                    <!-- <p>Start and monitor migration process</p> -->
                </div>
             </div>
              <div class="btn-group">
                <app-common-button label="Start" title="Start" [buttonId]="114" [critical]="true" buttonClass="startMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                        (clicked)="start()">
                    </app-common-button>
                <app-common-button label="Abort" title="Abort" [buttonId]="115" [critical]="true" buttonClass="abortMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [customStyles]="{backgroundColor: 'unset', border: '2px solid' + backgroundColorButton, color: 'black',justifyContent: 'flex-start' }"
                (clicked)="abort()">
            </app-common-button>
             </div>
             </div>

               <div class="run-box">
                 <div class="status-section">
                    <div class="status-row">
                        <label>Migration ID</label>
                        <span>{{mgrid}}</span>
                    </div>

                    <div class="status-row">
                        <label>Start Date & Time</label>
                        <span>{{mgrstartdt}}</span>
                    </div>

                    <div class="status-row">
                        <label>Status</label>
                        <span>{{mgrstatus}}</span>
                    </div>
               </div>
                <div class="process-section">
                      <label style="font-weight: 500; font-size: large;">Select Processes</label>
                       <form novalidate [formGroup]='FormValidStartRun'>
                         <div class="process-grid">
                            <div>
                                <label style="    font-weight: normal;
    font-size: 16px;">Object Data</label>
                                <mat-checkbox formControlName="globalCheckbox" ngDefaultControl [(ngModel)]="globalCheckbox" class="mat-checkbox-layout">
                                    <span>Global Extraction</span>  </mat-checkbox><br>

                                <mat-checkbox formControlName="extractionCheckbox" ngDefaultControl [(ngModel)]="extractionCheckbox" class="mat-checkbox-layout">
                                <span>Extract</span>  </mat-checkbox><br>

                                <mat-checkbox formControlName="transformationCheckbox" ngDefaultControl [(ngModel)]="transformationCheckbox" class="mat-checkbox-layout">
                                <span>Transform</span>  </mat-checkbox><br>

                                <mat-checkbox formControlName="preloadtransformationCheckbox" ngDefaultControl [(ngModel)]="preLoadTransformationCheckbox" class="mat-checkbox-layout">
                                    <span>Preload Transformation</span>  </mat-checkbox><br>


                                <mat-checkbox formControlName="loadCheckbox" ngDefaultControl [(ngModel)]="loadCheckbox" class="mat-checkbox-layout">
                                <span>Load</span>  </mat-checkbox><br>

                                <mat-checkbox formControlName="validationCheckbox" ngDefaultControl [(ngModel)]="validationCheckbox" class="mat-checkbox-layout">
                                <span>Validation</span>  </mat-checkbox><br>
                                </div>
                            <div>
                               <label style="font-weight: normal;font-size: 16px;">Attachments</label>
                                <mat-checkbox formControlName="attachextractCheckbox" ngDefaultControl [(ngModel)]="attachextractCheckbox" class="mat-checkbox-layout">
                                <span>Extract</span>  </mat-checkbox><br>

                                <mat-checkbox formControlName="ftpuploadCheckbox" ngDefaultControl [(ngModel)]="ftpuploadCheckbox" class="mat-checkbox-layout">
                                <span>FTP Upload</span>  </mat-checkbox><br>
                                 <app-common-button style="margin-top: 25px; "label="Save" title="Save"
                            [buttonId]="116" [critical]="true" width="110px"(clicked)="pauseProcess()">
                         </app-common-button>

                            </div>
                        </div>
                       </form>
                </div>
               </div>
        </div>
 </div>
   



    <div style="border-bottom: 0.01px ridge coral; margin: 2vw 15px -10px 15px;"></div>

    <!-- Added expansion panel for all three grids by kalpesh -->
    <!-- Updated code to make expanssion panel expanded on page load for all three grids by kalpesh -->
    <mat-expansion-panel [expanded] = "true" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 3%;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
        <mat-panel-title>
          <label style="font-size: 22px; font-weight: 500;" i18n="@@spmsUserReg" class="textColour">Migration Run History</label>
          <span class="ellipsis" id="header" (click)="openSaveForm($event,'migration')"style="display: block; text-align: center;">
            <span style="font-size: 35px; position: relative; top: -15px; margin-left: 5px; cursor: pointer;" title="Select Headers">&hellip;</span>
        </span>
            <span class="example-spacer"></span>
        </mat-panel-title>
        <mat-panel-description>

        </mat-panel-description>
      </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
            <!-- <div> -->


                <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

                   
                    <span class="example-spacer"></span>

                        <!-- <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Delete Objects" (click) = "deleteObjects()" id="121"[disabled]="!buttonIdList.includes(121)">
                            Delete Objects<em style="padding: 0px 0px 0px 5px;" class="fas fa-trash" title="Delete Objects"></em>
                        </button> -->
                        <app-common-button  label="Delete Objects" title="Delete Objects" icon="fas fa-trash"
             [buttonId]="121" [critical]="true" width="100px"(clicked)="deleteObjects()" [customStyles]="{width:'120px',display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'}">
          </app-common-button>
                        <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refreshRun()">
                            Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                        </button>
                        <button class="downloadrunHistory popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onDownloadRunhistory()">
                            Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select ngDefaultControl [(ngModel)]="RunpageSize" [ngModelOptions]="{standalone:true}" (ngModelChange)="onRunPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon">
                                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious()"></em>
                                </li>
                                <li>{{RuncurrentPage}}/{{RuntotalPages}}</li>
                                <li class="paginationliicon" style="padding:0;">
                                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext()"></em>
                                </li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast()"></em>
                        </div>

                </mat-toolbar>
            

                <div>

                    <ag-grid-angular style="height: 50vh;" id="Grid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsFormigration"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true" [components]="components"  [pagination]="true" [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" 

                [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" (paginationChanged)="onRunPaginationChanged()"
                (gridReady)="onGridReadymigration($event)" (cellClicked)="cellClickedObjects($event)" (contextmenu)="onRightClick($event)" (cellContextMenu)="onCellDoubleClicked($event)"     [isRowSelectable]="isRowSelectable" [allowContextMenuWithControlKey]="true" [rowClassRules]="rowClassRules"    [hidden]="!true">
                </ag-grid-angular>

                </div>

        </div>
      <div style="visibility: hidden; position: fixed;"
           [style.left.px]="menuTopLeftPosition.x"
           [style.top.px]="menuTopLeftPosition.y"
           [matMenuTriggerFor]="rightMenu"></div>


      <mat-menu #rightMenu="matMenu" >
        <ng-template matMenuContent >

          <div *ngIf="status=='In Progress'"  >
            <button mat-menu-item (click)="migrationSatus('Complete')">Complete</button>
            <button mat-menu-item (click)="migrationSatus('Aborted')">Abort</button>

            <button mat-menu-item (click)="edit()">Edit</button>

          </div>
          <div *ngIf="status=='Aborted'">
            <button mat-menu-item (click)="migrationSatus('Complete')">Complete</button>
            <button mat-menu-item (click)="migrationSatus('In Progress')">In Progress</button>
            <button *ngIf="showScheduler" mat-menu-item (click)="incrementalDataLoadSchedule()">Scheduler</button>
          </div>
          <div *ngIf="status=='Complete'">
            <button mat-menu-item (click)="migrationSatus('In Progress')">In Progress</button>
            <button *ngIf="showScheduler" mat-menu-item (click)="incrementalDataLoadSchedule()">Scheduler</button>
          </div>
          <!-- Added code for displaying the option of In Progress for failed migrations-->
          <div *ngIf="status=='Failed'">
            <button mat-menu-item (click)="migrationSatus('In Progress')">In Progress</button>
          </div>
          <!-- <div *ngIf="showScheduler">
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            title="Schedule Data Load"
            (click)="incrementalDataLoadSchedule()">
            Scheduler<em style="padding: 0px 0px 0px 10px;" class="fas fa-hourglass-half" title="Scheduler"></em>
        </button>
          </div> -->
          
        </ng-template>
      </mat-menu>

    </mat-expansion-panel>

    <mat-expansion-panel [expanded] = "true" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
        <mat-panel-title>
          <label style="font-size: 22px; font-weight: 500;" i18n="@@spmsUserReg" class="textColour">Migration Current Status</label>
            <span class="example-spacer"></span>
        </mat-panel-title>
        <mat-panel-description>
            
            <label>
                <input type="radio" style="font-size: medium; margin-left: 25px; margin-right: 5px;" name="grid" [(ngModel)]="selectedGrid" (change)="switch()" value="new" />  
                New View
              </label>
              <label>
                <input type="radio" style="font-size: medium; margin-left: 25px; margin-right: 5px;" name="grid" [(ngModel)]="selectedGrid" (change)="switch()" value="old" />  
                Old View
              </label>
              
              
            
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div *ngIf="selectedGrid === 'old'">
      <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
              


        <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

           
            <mat-radio-group (change)="caseData($event.value)" [(ngModel)]="loadingProcess" [disabled]="!isDisabled" aria-label="Select an option" style="padding: 5px;">
                <mat-radio-button [checked]="flag" style="font-size: medium;" value="CaseData">
                  Object Data
                  <span id="header" (click)="!isDisabled ? $event.stopPropagation() : openSaveForm($event, 'caseData')" title="Select Headers">
                    <span class="ellipsis" style="font-size: 24px; cursor: pointer; position: relative; top: -4px;">
                      &hellip;
                    </span>
                  </span>
                </mat-radio-button>
                <mat-radio-button style="font-size: medium; margin-left: 25px;" value="Attachments">Document Attachments</mat-radio-button>
                <!-- Added one more tab to the migration current status for global object status -->
                <mat-radio-button style="font-size: medium; margin-left: 25px;" value="GlobalData">Global Data</mat-radio-button>
              </mat-radio-group>
              
              
            <!-- <span class="example-spacer"></span> -->
          
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Re-Migrate" (click) = "onReMigrateClick()">
                Re-Migrate<em style="padding: 0px 0px 0px 10px;" title="Re-Migrate"></em>
            </button>

            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refresh()">
                Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
            </button>
            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">
                Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
            </button>
            <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                    <mat-label i18n="@@Targetpageno">Page No</mat-label>
                    <input matInput type="text" (input)="onSearchChange($event.target.value)">
                </mat-form-field>
            </div>
            <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                    <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                    <mat-select ngDefaultControl [(ngModel)]="pageSize" [ngModelOptions]="{standalone:true}" (ngModelChange)="onPageSizeChanged(value)">
                        <mat-option value="10" selected>10</mat-option>
                        <mat-option value="200">200</mat-option>
                        <mat-option value="300">300</mat-option>
                        <mat-option value="400">400</mat-option>
                    </mat-select>

                </mat-form-field>
            </div>
            <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
                <ul>
                    <li class="paginationliicon">
                        <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
                    </li>
                    <li>{{currentPage}}/{{totalPages}}</li>
                    <li class="paginationliicon" style="padding:0;">
                        <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
                    </li>
                </ul>
            </div>
            <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
            </div>

        </mat-toolbar>

    <div *ngIf='migrationTrace'>

        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsExtract" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"  [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components"(cellClicked)="cellClickedSets($event)" (gridReady)="onGridReadyCaseData($event)" [hidden]="!true"></ag-grid-angular>
    </div>

    <div *ngIf='transformTrace'>
        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (cellClicked)="docAttachedClicked($event)" (gridReady)="onGridReadyAttachmentsData($event)" [hidden]="!true"></ag-grid-angular>

    </div>
    <!--Added one more tab For Global data objects-->
    <div *ngIf='globaltrace'>
        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnHeaderForGlobalTab" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (gridReady)="onGridReadyGlobalData($event)" (cellClicked)="cellClickedGlobalExtractedData($event)" [hidden]="!true"></ag-grid-angular>

    </div>
</div>
</div>











    <div *ngIf="selectedGrid === 'new'">
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
              


                    <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

                       
                        <mat-radio-group (change)="caseData($event.value)" [(ngModel)]="loadingProcess" [disabled]="!isDisabled" aria-label="Select an option" style="padding: 5px;">
                            <mat-radio-button [checked]="flag" style="font-size: medium;" value="CaseData">
                              Object Data
                              <span id="header" (click)="!isDisabled ? $event.stopPropagation() : openSaveForm($event, 'caseData')" title="Select Headers">
                                <span class="ellipsis" style="font-size: 24px; cursor: pointer; position: relative; top: -4px;">
                                  &hellip;
                                </span>
                              </span>
                            </mat-radio-button>
                            <mat-radio-button style="font-size: medium; margin-left: 25px;" value="Attachments">Document Attachments</mat-radio-button>
                            <!-- Added one more tab to the migration current status for global object status -->
                            <mat-radio-button style="font-size: medium; margin-left: 25px;" value="GlobalData">Global Data</mat-radio-button>
                          </mat-radio-group>
                          
                          
                        <!-- <span class="example-spacer"></span> -->
                      
                          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Re-Migrate" (click) = "onReMigrateClick()">
                Re-Migrate<em style="padding: 0px 0px 0px 10px;" title="Re-Migrate"></em>
            </button>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refresh()">
                            Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                        </button>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">
                            Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select ngDefaultControl [(ngModel)]="pageSize" [ngModelOptions]="{standalone:true}" (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon">
                                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
                                </li>
                                <li>{{currentPage}}/{{totalPages}}</li>
                                <li class="paginationliicon" style="padding:0;">
                                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
                                </li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>

                    </mat-toolbar>
            
                <div *ngIf='migrationTrace'>

                    <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsExtract" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"  [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components"(cellClicked)="cellClickedSets($event)" (gridReady)="onGridReadyCaseData($event)" [hidden]="!true"></ag-grid-angular>
                </div>

                <div *ngIf='transformTrace'>
                    <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (cellClicked)="docAttachedClicked($event)" (gridReady)="onGridReadyAttachmentsData($event)" [hidden]="!true"></ag-grid-angular>

                </div>
                <!--Added one more tab For Global data objects-->
                <div *ngIf='globaltrace'>
                    <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnHeaderForGlobalTab" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" [components]="components" (gridReady)="onGridReadyGlobalData($event)" (cellClicked)="cellClickedGlobalExtractedData($event)" [hidden]="!true"></ag-grid-angular>

                </div>
        </div>
        </div>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded] = "true" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
        <mat-panel-title>
          <label style="font-size: 22px; font-weight: 500;" i18n="@@spmsUserReg" class="textColour">Object Current Status</label>
            <span class="example-spacer"></span>
        </mat-panel-title>
        <mat-panel-description>

        </mat-panel-description>
      </mat-expansion-panel-header>

        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
                <div>
                    <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
                        <!--Added Radio buttons for Object Grid-->
                        <mat-radio-group (change)="objectData($event)" [disabled]="!this.isDisabledForObjectGrid" aria-label="Select an option" style="padding: 5px;" [(ngModel)]="this.objectRadioValue">
                            <mat-radio-button   style="font-size: medium;" value="extractionObjects">Extraction</mat-radio-button>
                            <mat-radio-button  [disabled]="this.isDisableTransformbtn" style="font-size: medium; margin-left: 25px;" value="transformObjects">Transform</mat-radio-button>
                            <mat-radio-button  [disabled]="this.isDisableLoadbtn" style="font-size: medium; margin-left: 25px;" value="loadObjects">Load</mat-radio-button>
                        </mat-radio-group>
                        <!-- -->
                       
                        <span class="example-spacer"></span>
                        <button id="refreshObjects" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refreshObjects()">
                            Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                        </button>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onDownloadLoad()">
                            Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onloadSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select ngDefaultControl [(ngModel)]="loadpageSize" [ngModelOptions]="{standalone:true}" (ngModelChange)="onloadPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onloadBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon">
                                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onloadBtPrevious()"></em>
                                </li>
                                <li>{{loadcurrentPage}}/{{loadtotalPages}}</li>
                                <li class="paginationliicon" style="padding:0;">
                                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onloadBtNext()"></em>
                                </li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onloadBtLast()"></em>
                        </div>
                    </mat-toolbar>
                </div>

                <div>
            <!--Added code for GRID for Extraction and Transfromation-->
                <div *ngIf="extractionInstrictionTrace">
                        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsExtractionAndTransformation" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onloadPaginationChanged()" [components]="components"  (gridReady)="retrieveInstructionsBasedOnActivity($event)" [hidden]="!true"></ag-grid-angular> 
                </div>
                  <div *ngIf='loadInstructionTrace'>
                    <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsLoader" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onloadPaginationChanged()" [components]="components"        (gridReady)="retrieveInstructionsBasedOnActivity($event)" [hidden]="!true"></ag-grid-angular>
                  </div>
                    <div *ngIf='attachmentLoadInstructionTrace'>
                      <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsLoadAttachment" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules" (paginationChanged)="onloadPaginationChanged()" [components]="components"        (gridReady)="onGridReadyDocAttachment($event)" [hidden]="!true"></ag-grid-angular>

                    </div>
                  </div>


        </div>
    </mat-expansion-panel>
</div>
